import src from "IMAGE";
export default { src, width: 2191, height: 484, blurWidth: 0, blurHeight: 0};
